import { render, staticRenderFns } from "./compliance-status-label.vue?vue&type=template&id=370ff687&scoped=true&lang=pug"
import script from "./compliance-status-label.vue?vue&type=script&lang=ts"
export * from "./compliance-status-label.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ff687",
  null
  
)

export default component.exports